export default "__VITE_ASSET__BWoHLPqf__"